import { CalendarDaysIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { FC, useCallback, useState } from "react";
import { ICustomTripWorkingDayPattern } from "../../../interfaces/endpoints/patterns/ICustomTripWorkingDayPattern";
import { CustomTripWorkingDayType } from "../../../interfaces/endpoints/trips/Trips.types";
import { getPatternsSelectList } from "../../../services/CustomTripWorkingDayPattern.service";
import Select from "../../ui/select/Select";
import ConfirmPatternModal from "./ConfirmPatternModal";

interface PatternSelectProps {
  onPatternSelect: (pattern: ICustomTripWorkingDayPattern | null) => void;
  value: ICustomTripWorkingDayPattern | null;
  onRefreshNeeded?: () => void;
}

const PatternSelect: FC<PatternSelectProps> = ({ onPatternSelect, value, onRefreshNeeded }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedPattern, setSelectedPattern] = useState<ICustomTripWorkingDayPattern | null>(null);

  const handlePatternSelect = (pattern: ICustomTripWorkingDayPattern | null) => {
    if (pattern) {
      setSelectedPattern(pattern);
      setShowConfirmModal(true);
    } else {
      onPatternSelect(null);
    }
  };

  const handleConfirm = (pattern: ICustomTripWorkingDayPattern) => {
    onPatternSelect(pattern);
    setShowConfirmModal(false);
  };

  const handleClose = () => {
    setShowConfirmModal(false);
    setSelectedPattern(null);
  };

  const handlePatternDeleted = useCallback(() => {
    onPatternSelect(null);
    onRefreshNeeded?.();
  }, [onPatternSelect, onRefreshNeeded]);

  const getPatternIcon = (pattern: ICustomTripWorkingDayPattern) => {
    return pattern.type === CustomTripWorkingDayType.ExceptionDate ? (
      <XCircleIcon className="w-4 h-4 mr-2 text-red-500" />
    ) : (
      <CalendarDaysIcon className="w-4 h-4 mr-2 text-green-500" />
    );
  };

  return (
    <>
      <Select
        label="Zgjedh një kalendar të mëparshëm"
        placeholder="Zgjedhni kalendarin"
        selectedItem={value}
        asyncFunc={getPatternsSelectList}
        onSelectedItemChange={handlePatternSelect}
        getOptionLabel={(o: ICustomTripWorkingDayPattern) => (
          <span className="flex items-center">
            {getPatternIcon(o)}
            <span>{o.name}</span>
          </span>
        )}
        itemToString={(o: ICustomTripWorkingDayPattern | null) => o?.name || ""}
      />
      <ConfirmPatternModal
        show={showConfirmModal}
        onClose={handleClose}
        pattern={selectedPattern}
        onConfirm={handleConfirm}
        onPatternDeleted={handlePatternDeleted}
      />
    </>
  );
};

export default PatternSelect;
